import { createEvent } from "ics";

export const addToCalender_ = (props) => {
    const { title, description, location, start, duration, status } = props;
    createEvent(
        {
            title,
            description,
            location,
            start, // [YYYY, M, D, H, M]
            duration,
            status,
        },
        (error, value) => {
            if (error) {
                alert(error);
                return;
            }

            // Create and download the .ics file
            const blob = new Blob([value], { type: "text/calendar;charset=utf-8" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = "reminder.ics";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    );
};

export const addToCalender_2 = (props) => {
    const { title, description, location, start, duration, status = "CONFIRMED" } = props;

    // Convert start array to Date
    const startDate = new Date(start[0], start[1] - 1, start[2], start[3], start[4]);

    // Add duration to get endDate
    const endDate = new Date(startDate.getTime());
    if (duration?.hours) endDate.setHours(endDate.getHours() + duration.hours);
    if (duration?.minutes) endDate.setMinutes(endDate.getMinutes() + duration.minutes);

    // Format date as YYYYMMDDTHHmmssZ
    const formatDate = (date) => {
        return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    };

    const uid = `${Date.now()}@thetransformationcollective.org`;

    const icsContent = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//Your App Name//EN",
        "CALSCALE:GREGORIAN",
        "BEGIN:VEVENT",
        `UID:${uid}`,
        `DTSTAMP:${formatDate(new Date())}`,
        `DTSTART:${formatDate(startDate)}`,
        `DTEND:${formatDate(endDate)}`,
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
        `STATUS:${status}`,
        "END:VEVENT",
        "END:VCALENDAR"
    ].join("\r\n");

    // Create and download the file
    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "event.ics";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const addToCalender = (props) => {
    const {
        title,
        description,
        location,
        start,
        duration,
        status = "CONFIRMED",
        repeat = "never", // default
        time, // optional: [HH, mm]
        fileName = "event.ics"
    } = props;

    // Convert start into Date (accepts array or Date object)
    let startDate;
    if (Array.isArray(start)) {
        startDate = new Date(start[0], start[1] - 1, start[2], start[3], start[4]);
    } else if (start instanceof Date) {
        startDate = new Date(start);

        // if time is provided, override hours/minutes
        if (Array.isArray(time)) {
            startDate.setHours(time[0], time[1], 0, 0);
        }
    } else {
        throw new Error("Invalid start format. Must be [YYYY, MM, DD, HH, mm] or Date object.");
    }

    // Add duration to get endDate
    const endDate = new Date(startDate.getTime());
    if (duration?.hours) endDate.setHours(endDate.getHours() + duration.hours);
    if (duration?.minutes) endDate.setMinutes(endDate.getMinutes() + duration.minutes);

    // Format date as YYYYMMDDTHHmmssZ
    const formatDate = (date) => {
        return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    };

    const uid = `${Date.now()}@thetransformationcollective.org`;

    // Map repeat options into RRULE syntax
    const getRepeatRule = (repeat) => {
        switch (repeat) {
            case "daily":
                return "RRULE:FREQ=DAILY";
            case "weekly":
                return "RRULE:FREQ=WEEKLY";
            case "monthly":
                return "RRULE:FREQ=MONTHLY";
            case "yearly":
                return "RRULE:FREQ=YEARLY";
            case "weekdays":
                return "RRULE:FREQ=DAILY;BYDAY=MO,TU,WE,TH,FR";
            default:
                return null; // no repeat
        }
    };

    const icsContent = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//Your App Name//EN",
        "CALSCALE:GREGORIAN",
        "BEGIN:VEVENT",
        `UID:${uid}`,
        `DTSTAMP:${formatDate(new Date())}`,
        `DTSTART:${formatDate(startDate)}`,
        `DTEND:${formatDate(endDate)}`,
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
        `STATUS:${status}`,
        getRepeatRule(repeat), // add rule if exists
        "END:VEVENT",
        "END:VCALENDAR"
    ].filter(Boolean).join("\r\n");

    // Create and download the file
    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};






// USAGE EXAMPLES:

// // Single event
// addToCalender({
//   title: "Morning Prayer Meeting – TSO Ministries",
//   description: "Start your day with God. 🙏🏽",
//   location: "https://zoom.us/link",
//   start: [2025, 7, 3, 6, 0],
//   duration: { hours: 0, minutes: 30 },
//   repeat: "never"
// });

// // Weekdays only
// addToCalender({
//   title: "Morning Prayer Meeting – TSO Ministries",
//   description: "Start your day with God. 🙏🏽",
//   location: "https://zoom.us/link",
//   start: [2025, 7, 3, 6, 0],
//   duration: { hours: 0, minutes: 30 },
//   repeat: "weekdays"
// });

// // Weekly event
// addToCalender({
//   title: "Sunday Service",
//   description: "Join us live!",
//   location: "https://zoom.us/link",
//   start: [2025, 7, 6, 10, 0],
//   duration: { hours: 2, minutes: 0 },
//   repeat: "weekly"
// });



// addToCalender({
//   title: "Morning Prayer",
//   description: "Start your day with God 🙏🏽",
//   location: "https://zoom.us/link",
//   start: [2025, 7, 3, 6, 0],
//   duration: { hours: 0, minutes: 30 },
//   repeat: "weekdays"
// });


// addToCalender({
//   title: "Morning Prayer",
//   description: "Start your day with God 🙏🏽",
//   location: "https://zoom.us/link",
//   start: new Date(),
//   time: [6, 0], // <-- overrides today's time
//   duration: { hours: 0, minutes: 30 },
//   repeat: "weekdays"
// });


// addToCalender({
//   title: "Evening Fellowship",
//   description: "Worship & Word",
//   location: "https://zoom.us/link",
//   start: new Date(),
//   time: [19, 30], // 7:30 PM
//   duration: { hours: 1, minutes: 0 },
//   repeat: "weekly"
// });